/* import __COLOCATED_TEMPLATE__ from './tab-button.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { service } from '@ember/service';
import Constants from '../utils/constants';

export default class TabButton extends Component {
  @service intl;
  @service tabService;

  get isEnabled() {
    return (
      (this.args.type === Constants.TAB.PREVIOUS &&
        this.tabService.previousTab &&
        !this.tabService.previousTab.isDisabled(this.args.signalChainHandler.dac.selected)) ||
      (this.args.type === Constants.TAB.NEXT &&
        this.tabService.nextTab &&
        !this.tabService.nextTab.isDisabled(this.args.signalChainHandler.dac.selected))
    );
  }

  get isPrevious() {
    return this.args.type === Constants.TAB.PREVIOUS;
  }

  get isNext() {
    return this.args.type === Constants.TAB.NEXT;
  }

  get label() {
    return this.intl.t(`nav.${this.args.type}_tab`);
  }

  get icon() {
    return this.args.type === 'next' ? 'Icon_Expand' : 'Icon_Collapse';
  }

  @action incrementTab() {
    this.tabService.setTab(Constants.TAB[this.args.type.toUpperCase()]);
    if (this.args.updateAppData) this.args.updateAppData();
  }
}
